import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { SpecialEmblemStatusModel } from "@/features/emblems/api/useSpecialEmblemStatus";

export const useUnlockSpecialEmblem = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, string> = specialEmblemId => {
		return http({
			method: "POST",
			url: `/emblem/special/${specialEmblemId}/unlock`,
			body: undefined
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, specialEmblemId) => {
			queryClient.setQueryData<SpecialEmblemStatusModel>(["specialEmblemStatus", specialEmblemId], { status: "Unlocked" });
		}
	});
};
